"use strict";

/*==================================================
  CONTACT PREMIUM
==================================================*/

window.CP = window.CP || {};

/*==================================================
  FILE UPLOAD
==================================================*/

window.CP.initFileUpload = function () {

    const fileInputs = document.querySelectorAll("[data-file-input]");

    if (!fileInputs.length) return;

   
    fileInputs.forEach(function (input) {

        bindFileInput(input);

    });

};

/*==================================================
  FILE INPUT
==================================================*/

function bindFileInput(input){

    const upload = input.closest(".cp-file-upload");
    const empty = upload.querySelector("[data-file-empty]");
    const selected = upload.querySelector("[data-file-selected]");
    const fileName = upload.querySelector("[data-file-name]");
    const fileSize = upload.querySelector("[data-file-size]");
    const preview = upload.querySelector("[data-file-preview]");
    const changeButton = upload.querySelector("[data-file-change]");
    const removeButton = upload.querySelector("[data-file-remove]");
    const icon = upload.querySelector(".cp-file-selected-icon");
    const message = upload.querySelector("[data-file-message]");

upload.addEventListener("dragover", function (event) {

    event.preventDefault();


});

upload.addEventListener("dragenter", function (event) {

    event.preventDefault();

    upload.classList.add("is-dragging");

});

upload.addEventListener("dragleave", function () {

    upload.classList.remove("is-dragging");

});

upload.addEventListener("drop", function (event) {

    event.preventDefault();

    upload.classList.remove("is-dragging");

    const file = event.dataTransfer.files[0];
    if (!file) return;

        message.textContent = "";

        message.className = "cp-file-message";

        processFile(

            file,

            input,

            empty,

            selected,

            fileName,

            fileSize,

            preview,

            icon,

            message

        );

});



changeButton.addEventListener("click", function () {

    input.click();

});

removeButton.addEventListener("click", function () {

    resetFileInput(
        input,
        empty,
        selected,
        preview,
        icon,
        fileName,
        fileSize,
        message
    );

});

    input.addEventListener("change", function () {

        const file = input.files[0];

            message.textContent = "";

            message.className = "cp-file-message";

            if (!file) return;
            processFile(

                file,

                input,

                empty,

                selected,

                fileName,

                fileSize,

                preview,

                icon,

                message

            );

    });

}

/*==================================================
  VALIDATE FILE
==================================================*/

function validateFile(file, message){

    const MAX_SIZE = 15 * 1024 * 1024;

        if (file.size > MAX_SIZE){

            message.textContent =
                "❌ El archivo supera el tamaño máximo permitido (15 MB).";

            message.className =
                "cp-file-message error";

            return false;

        }

    const allowedTypes = [

        "application/pdf",

        "image/jpeg",

        "image/jpg",

        "image/png",

        "image/webp"

    ];

        if (!allowedTypes.includes(file.type)){

            message.textContent =
                "❌ Solo se permiten archivos PDF, JPG, PNG y WEBP.";

            message.className =
                "cp-file-message error";

            return false;

        }


    return true;

}

/*==================================================
  SHOW SELECTED FILE
==================================================*/

function showSelectedFile(
    file,
    empty,
    selected,
    fileName,
    fileSize,
    preview,
    icon,
    message
){

    empty.hidden = true;

    selected.hidden = false;

    fileName.textContent = file.name;

    fileSize.textContent =
        (file.size / 1024 / 1024).toFixed(2) + " MB";

if (file.type.startsWith("image/")) {

    icon.hidden = true;

    const objectUrl = URL.createObjectURL(file);

    preview.src = objectUrl;

    preview.hidden = false;

    preview.onload = function () {

        URL.revokeObjectURL(objectUrl);

    };

} else {

    icon.hidden = false;

    preview.hidden = true;

    preview.src = "";

}

    message.textContent = "✅ Archivo listo para enviar.";

    message.className = "cp-file-message success";

}

/*==================================================
  PROCESS FILE
==================================================*/

function processFile(

    file,

    input,

    empty,

    selected,

    fileName,

    fileSize,

    preview,

    icon,

    message

){

    if (!validateFile(file, message)){

        input.value = "";

        return;

    }

    showSelectedFile(

        file,

        empty,

        selected,

        fileName,

        fileSize,

        preview,

        icon,

        message

    );

}

/*==================================================
  RESET FILE
==================================================*/

function resetFileInput(

    input,

    empty,

    selected,

    preview,

    icon,

    fileName,

    fileSize,

    message

){

    
    input.value = "";
    selected.hidden = true;
    empty.hidden = false;
    fileName.textContent = "";

    fileSize.textContent = "";

    message.textContent = "";

    message.className = "cp-file-message";
    if (preview){

        preview.src = "";

        preview.hidden = true;

    }

    if (icon){

        icon.hidden = false;

    }

}